const MetaTraderWebTerminalContentTwo = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Instant Browser Access</h4>
              </div>
              <p>
                Trade directly from Chrome, Firefox, Safari, or Edge, no
                downloads or installations required. Access your account
                instantly and manage trades securely from any device connected
                to the internet.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Real-Time Market Data</h4>
              </div>
              <p>
                Monitor live price movements and stay ahead of the market. The
                Web Terminal delivers fast, accurate quotes and responsive
                charts to ensure every decision is backed by real-time data.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Full Order Management</h4>
              </div>
              <p>
                Place, modify, and close trades effortlessly. Whether you’re
                executing market, pending, or stop orders, the Web Terminal
                provides full trading functionality just like the desktop
                version.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Enhanced Security Protocols</h4>
              </div>
              <p>
                Built with advanced SSL encryption and data protection measures,
                the Web Terminal ensures all your trading information and funds
                remain safe from unauthorized access.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTraderWebTerminalContentTwo;
